import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=f9b4cb54&"
import script from "./Activity.vue?vue&type=script&lang=ts&"
export * from "./Activity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports